"use client";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function IC_EN_01({ width, height }) {
  const { theme } = useTheme();
  const [color, setColor] = useState("#324ba6");

  useEffect(() => {
    setColor(theme === "dark" ? "#324BA6" : "#324ba6");
  }, [theme]);
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
    >
      <defs>
        <style>
          {`.cls-1 {
        stroke-width: 0px;
        fill: ${color};
      }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m20.19,30c-.6,0-1.08-.49-1.08-1.08v-2.69h-4.59v2.69c0,.6-.49,1.08-1.08,1.08h-2.7c-.6,0-1.08-.49-1.08-1.08v-2.69h-1.51c-1.26,0-2.29-1.03-2.29-2.29v-1.81h-2.53c-.6,0-1.08-.49-1.08-1.08v-2.79c0-.6.49-1.08,1.08-1.08h2.53v-8.11h-2.53c-.6,0-1.08-.49-1.08-1.08v-2.79c0-.6.49-1.08,1.08-1.08h2.53v-1.81c0-1.26,1.03-2.29,2.29-2.29h17.35c1.26,0,2.29,1.03,2.29,2.29v21.65c0,1.26-1.03,2.29-2.29,2.29h-1.51v2.69c0,.6-.49,1.08-1.08,1.08h-2.7Zm-.12-.96h2.94v-2.81h-2.94v2.81Zm-9.46,0h2.94v-2.81h-2.94v2.81ZM8.13.96c-.73,0-1.33.59-1.33,1.33v21.65c0,.73.59,1.33,1.33,1.33h17.35c.73,0,1.33-.59,1.33-1.33V2.29c0-.73-.59-1.33-1.33-1.33H8.13ZM3.19,21.17h2.65v-3.04h-2.65v3.04Zm0-13.07h2.65v-3.04h-2.65v3.04Z"
      />
      <path
        className="cls-1"
        d="m16.84,22.58c-.07,0-.13-.01-.19-.04-.12-.05-.21-.14-.26-.26-.05-.12-.05-.25,0-.37l.85-1.97h-1.61c-.17,0-.31-.08-.4-.22-.09-.14-.1-.31-.03-.46l1.2-2.65c.08-.17.25-.28.44-.28.07,0,.14.01.2.04.12.05.21.15.25.27.05.12.04.25-.01.37l-.89,1.96h1.59c.16,0,.31.08.4.22.09.14.11.3.04.46l-1.14,2.65c-.08.18-.25.29-.44.29h0Z"
      />
      <path
        className="cls-1"
        d="m10.68,9.06c-.6,0-1.08-.49-1.08-1.08v-2.79c0-.6.49-1.08,1.08-1.08h12.26c.6,0,1.08.49,1.08,1.08v2.79c0,.6-.49,1.08-1.08,1.08h-12.26Zm8.86-.96h3.52v-3.04h-3.52v3.04Zm-4.49,0h3.52v-3.04h-3.52v3.04Zm-4.49,0h3.52v-3.04h-3.52v3.04Z"
      />
      <path
        className="cls-1"
        d="m11.75,13.6c-.27,0-.48-.22-.48-.48s.22-.48.48-.48h9.79c.27,0,.48.22.48.48s-.22.48-.48.48h-9.79Z"
      />
    </svg>
  );
}
